const getTransportSubcategory = (advert) => {
  if (advert.advert_item_type === 'road_train') {
    return `road_train_${advert.advert_items[0].type}`;
  }
  return '';
};

export default getTransportSubcategory;
